import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    const timestamp = new Date().toISOString();
    console.log(`[${timestamp}][AuthCallback] Checking auth state, user:`, user, 'loading:', loading);
    if (!loading) {
      if (user) {
        console.log(`[${timestamp}][AuthCallback] User authenticated, redirecting to /, user:`, user.email);
        navigate('/', { replace: true });
      } else {
        console.log(`[${timestamp}][AuthCallback] No user detected, redirecting to /`);
        navigate('/', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-white text-center">
        <span className="animate-spin inline-block h-8 w-8 border-2 border-white border-t-transparent rounded-full"></span>
        <p className="mt-4 text-white/70">Completing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
